




























import { defineComponent, PropType } from "@vue/composition-api";
import { AgeVerificationStatus } from "@scrile/api-provider/dist/api/AgeVerificationProvider";
import BaseIcon from "@/components/Base/BaseIcon";
import BaseButton from "@/components/BaseButton";
import BaseSpinner from "@/components/BaseSpinner";

export default defineComponent({
  name: "AgeVerificationStatusView",
  components: { BaseButton, BaseIcon, BaseSpinner },
  props: {
    status: { type: String as PropType<AgeVerificationStatus>, required: true },
    processing: { type: Boolean, default: false },
  },
  setup() {
    return {
      AgeVerificationStatus,
    };
  },
});
